import React from "react";
import { Label } from "@streeteasy/design-system";
import { string } from "prop-types";

import * as S from "./styled";

const LocationSearch = React.forwardRef(({ id, ...props }, ref) => (
  <>
    <Label htmlFor={id}>Neighborhoods and Boroughs</Label>
    <S.Combobox id={id} {...props} ref={ref} />
  </>
));

LocationSearch.propTypes = {
  id: string.isRequired
};

export default LocationSearch;
